import { render, staticRenderFns } from "./start.vue?vue&type=template&id=4ed4726b&scoped=true&"
import script from "./start.vue?vue&type=script&setup=true&lang=js&"
export * from "./start.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4726b",
  null
  
)

export default component.exports